import { render, staticRenderFns } from "./AgentSettlements.vue?vue&type=template&id=f310d294&scoped=true&"
import script from "./AgentSettlements.vue?vue&type=script&lang=js&"
export * from "./AgentSettlements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f310d294",
  null
  
)

export default component.exports